import styles from './downloadSalePDFModal.module.css'
import { fileHelpers, usePDFActions } from "../../../../../features/files"
import { Modal, ModalId } from "../../../../../features/ui"
import { SaleOrder } from "../../../state/types"
import { SalePDF } from "../sale-pdf/salePDF"
import { FileTile, FileType } from "../../../../../features/ui"
import { useEffect, useState } from "react"

type Props = {
    sale?: SaleOrder
}

export const DownloadSalePDFModal = (props: Props) => {
    const { sale } = props

    const [pdfName, setPdfName] = useState<string>()

    const { saleFileName } = fileHelpers

    const { generatePDF, printPDF, isPrinting } = usePDFActions()

    useEffect(() => {
        sale && setPdfName(saleFileName(sale.code))
    }, [sale])

    const pdfId = 'sale-pdf'

    const onSubmit = () => {
        pdfName && generatePDF(pdfId, pdfName)
    }

    const renderHiddenPDF = () => sale ? (
        <div className={styles.hidden}>
            <SalePDF
                id={pdfId}
                sale={sale}
            />
        </div>
    ) : <></>

    return (
        <Modal
            modalId={ModalId.DOWNLOAD_SALE_PDF}
            title="Descargar Venta"
            submitLabel="Descargar"
            submitIcon="download"
            onSubmit={onSubmit}
            secondaryLabel="Imprimir"
            secondaryIcon="printer"
            disableSecondary={isPrinting || !pdfName}
            onSecondarySubmit={() => printPDF(pdfId)}
        >
            <FileTile fileType={FileType.PDF} fileName={pdfName}/>
            {renderHiddenPDF()}
        </Modal>
    )
}
